import autosize from 'autosize'

export default {
  mounted (el, binding) {
    if (binding.value && el.tagName === 'TEXTAREA') {
      autosize(el)
    }
  },

  updated (el, binding) {
    if (binding.value && el.tagName === 'TEXTAREA') {
      autosize.update(el)
    }
  },

  unmounted (el) {
    autosize.destroy(el)
  },
}
